import { RxJsWebSocketService } from './rxjs-websocket-service';
import { LocalApiService } from '../local-api/local-api.service';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
var StbWebSocketService = /** @class */ (function () {
    function StbWebSocketService(rxJsWebSocketService, localApiService) {
        this.rxJsWebSocketService = rxJsWebSocketService;
        this.localApiService = localApiService;
    }
    StbWebSocketService.prototype.openWebsocketToSTB = function () {
        console.log('%c Connecting to the STB API...', 'color: green; background:yellow;font-size:16px;');
        return this.rxJsWebSocketService.createObservableSocket(this.localApiService.STB_WEBSOCKET_URL).pipe(map(function (data) {
            console.log(JSON.stringify(data));
            return true;
        }), catchError(function (err) {
            console.log('%c Error connecting to the stb API', 'color: white; background: red;font-size:16px');
            return of(false);
        }));
    };
    StbWebSocketService.prototype.sendProductActivationMessage = function (productIds, productName) {
        if (this.rxJsWebSocketService.isAvailable()) {
            console.log('websocket available to send');
            this.rxJsWebSocketService.sendMessage({
                edsProductId: productIds,
                commercialName: productName
            });
            return of(true);
        }
        else {
            console.log('Unable to send stb message. Connection not available.');
            return of(false);
        }
    };
    return StbWebSocketService;
}());
export { StbWebSocketService };
